import React, { useState, useEffect } from 'react';
import { Modal } from 'react-responsive-modal';
import 'react-responsive-modal/styles.css';
import styled from 'styled-components';
import '../../styles/CustomModal.css';
import DropdownSelect from '../../components/DropdownSelect';
import { useToast } from '../../controller/ToastController';
import StoreController, { CurrentStoreContext, StaffType } from '../../controller/StoreController';
import { useOutletContext } from 'react-router-dom';

type Props = {
  isVisible: boolean;
  setVisible: (bVisible: boolean) => void;
  renderStaffList: any;
  staffData: StaffType | null;
};

const hourList: any = [];
const earlyHourList: any = [];
const minuteList: any = [];
for (let i = 0; i <= 24; i++) {
  hourList.push({
    key: i,
    value: i > 9 ? `${i}` : `0${i}`,
    label: i > 9 ? `${i}시` : `0${i}시`,
    name: i > 9 ? `${i}시` : `0${i}시`,
  });
}
for (let i = 0; i < 12; i++) {
  minuteList.push({
    key: i,
    value: i > 1 ? `${i * 5}` : `0${i * 5}`,
    label: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
    name: i > 1 ? `${i * 5}분` : `0${i * 5}분`,
  });
}
for (let i = 1; i <= 6; i++) {
  earlyHourList.push({
    key: i + 24,
    value: i + 24 > 9 ? `${i + 24}` : `0${i + 24}`,
    label: `새벽 ${i}시`,
    name: `새벽 ${i}시`,
  });
}
const days: { label: string; value: number }[] = [
  { label: '월요일', value: 1 },
  { label: '화요일', value: 2 },
  { label: '수요일', value: 3 },
  { label: '목요일', value: 4 },
  { label: '금요일', value: 5 },
  { label: '토요일', value: 6 },
  { label: '일요일', value: 0 },
];

const AddStaffModal = ({ isVisible, setVisible, renderStaffList, staffData }: Props) => {
  const showToast = useToast();
  const { currentStore } = useOutletContext<CurrentStoreContext>();
  const [name, setName] = useState<string>('');
  const [selectedDays, setSelectedDays] = useState<number[]>([]);
  const [isAllTimeSelected, setIsAllTimeSelected] = useState(false);
  const [startHour, setStartHour] = useState<any>(hourList[0]);
  const [startMin, setStartMin] = useState<any>(minuteList[0]);
  const [endHour, setEndHour] = useState<any>(hourList[1]);
  const [endMin, setEndMin] = useState<any>(minuteList[0]);
  const [phone, setPhone] = useState<string>('');
  const [overnight, setOvernight] = useState<number>(0);
  const [employeeId, setEmployeeId] = useState<number | null>(null);

  const [isPush, setIsPush] = useState<number>(0);

  const onCloseModal = () => {
    setVisible(false);
    reset();
  };

  const handleDayClick = (dayValue: number) => {
    setSelectedDays((prevSelectedDays: any) =>
      prevSelectedDays.includes(dayValue)
        ? prevSelectedDays.filter((d: number) => d !== dayValue)
        : [...prevSelectedDays, dayValue],
    );
  };
  const handleDayAllClick = () => {
    if (selectedDays.length === days.length) {
      setSelectedDays([]);
    } else {
      setSelectedDays(days.map((day) => day.value));
    }
  };
  const onChangeName = (e: any) => {
    setName(e.target.value);
  };
  const onChangePhone = (e: any) => {
    setPhone(e.target.value);
  };
  const onChangeStartHour = (e: any) => {
    setStartHour(e);
  };
  const onChangeStartMin = (e: any) => {
    setStartMin(e);
  };
  const onChangeEndHour = (e: any) => {
    setEndHour(e);

    const hourValue = parseInt(e.value, 10);
    if (hourValue >= 25 && hourValue <= 30) {
      setOvernight(1);
    } else {
      setOvernight(0);
    }
  };
  const onChangeEndMin = (e: any) => {
    setEndMin(e);
  };
  const handleAllTime = () => {
    if (isAllTimeSelected) {
      setEndHour(hourList[1]);
    } else {
      setEndHour(hourList[24]);
    }

    setStartHour(hourList[0]);
    setStartMin(minuteList[0]);
    setEndMin(minuteList[0]);
    setOvernight(0);
    setIsAllTimeSelected(!isAllTimeSelected);
  };
  const getFormattedStartTime = () => {
    return `${startHour.value}:${startMin.value}`;
  };
  const getFormattedEndTime = () => {
    return `${endHour.value}:${endMin.value}`;
  };
  const reset = () => {
    setName('');
    setSelectedDays([]);
    setStartHour(hourList[0]);
    setStartMin(minuteList[0]);
    setEndHour(hourList[1]);
    setEndMin(minuteList[0]);
    setPhone('');
    setOvernight(0);
    setEmployeeId(null);
  };

  const setConciergeList = async () => {
    try {
      if (name === '') {
        showToast('직원 이름을 입력해주세요.', 'error');
      } else if (selectedDays.length === 0) {
        showToast('근무요일을 선택해주세요.', 'error');
      } else if (phone === '') {
        showToast('핸드폰번호를 입력해주세요.', 'error');
      } else {
        const oParams = {
          employee_id: employeeId,
          store_id: currentStore.value,
          name: name,
          work_days: selectedDays.join(','),
          start_time: getFormattedStartTime(),
          end_time: getFormattedEndTime(),
          overnight: overnight,
          phone_number: phone,
          is_push_noti: isPush,
        };

        const oResponse = await StoreController.setEmployee(oParams);
        if (oResponse && oResponse.data) {
          const oRes = oResponse.data;
          if (oRes && oRes.data) {
            onCloseModal();
            showToast('저장되었습니다.');
            renderStaffList();
          }
          console.log('oRes--->', oRes);
        }
      }
    } catch (e) {
      console.error('err => ', e);
    }
  };
  useEffect(() => {
    if (isVisible && staffData) {
      const [startHourValue, startMinuteValue] = staffData.start_time.split(':');
      const [endHourValue, endMinuteValue] = staffData.end_time.split(':');

      setName(staffData.name);
      setSelectedDays(staffData.work_days.split(',').map((day: string) => parseInt(day)));
      setStartHour(hourList.find((hour: any) => hour.value === startHourValue));
      setStartMin(minuteList.find((minute: any) => minute.value === startMinuteValue));
      setEndHour([...hourList, ...earlyHourList].find((hour: any) => hour.value === endHourValue));
      setEndMin(minuteList.find((minute: any) => minute.value === endMinuteValue));
      setPhone(staffData.phone_number);
      setOvernight(staffData.overnight);
      setEmployeeId(staffData.employee_id);
      setIsPush(staffData.is_push_noti);
    }
  }, [isVisible, staffData]);
  useEffect(() => {
    if (
      startHour === hourList[0] &&
      startMin === minuteList[0] &&
      endHour === hourList[24] &&
      endMin === minuteList[0]
    ) {
      setIsAllTimeSelected(true);
    } else {
      setIsAllTimeSelected(false);
    }
  }, [startHour, startMin, endHour, endMin]);

  return (
    <Modal
      open={isVisible}
      onClose={onCloseModal}
      center
      classNames={{
        overlay: 'checkoutDetailModalOverlay',
        modal: 'checkoutDetailModal',
        root: 'customModalRoot',
      }}
      animationDuration={150}>
      <Style>
        <div className="modalWrapper">
          <div className="modalTitle">
            <div className="headerBar" />
            <h2>{employeeId === null ? '직원 추가하기' : '직원 수정하기'}</h2>
          </div>
          <div className="modalContent">
            <div className="content">
              <div className="title">
                <h3>직원 이름</h3>
                <span>(필수)</span>
              </div>
              <input
                type="text"
                value={name}
                onChange={(e) => onChangeName(e)}
                placeholder="직원 이름을 입력해주세요"
              />
            </div>
            <div className="content">
              <div className="title">
                <h3>근무요일</h3>
                <span>(필수)</span>
                <button
                  onClick={handleDayAllClick}
                  className={`allSelectButton ${
                    selectedDays.length === days.length ? 'active' : ''
                  }`}>
                  전체선택
                </button>
              </div>
              <div className="dayButtonWrap">
                {days.map((day) => (
                  <button
                    key={day.value}
                    onClick={() => handleDayClick(day.value)}
                    className={`dayButton ${selectedDays.includes(day.value) && 'active'}`}>
                    {day.label}
                  </button>
                ))}
              </div>
            </div>
            <div className="content">
              <div className="title">
                <h3>근무시간</h3>
                <span>(필수)</span>
                <button
                  onClick={handleAllTime}
                  className={`allSelectButton ${isAllTimeSelected ? 'active' : ''}`}>
                  하루 전체 근무
                </button>
              </div>
              <div className="selectDateWrap">
                <div className="dateSelect">
                  <DropdownSelect
                    options={hourList}
                    defaultValue={startHour}
                    onChangeValue={onChangeStartHour}
                  />
                </div>
                :
                <div className="dateSelect">
                  <DropdownSelect
                    options={minuteList}
                    defaultValue={startMin}
                    onChangeValue={onChangeStartMin}
                  />
                </div>
                ~
                <div className="dateSelect">
                  <DropdownSelect
                    options={[...hourList, ...earlyHourList]}
                    defaultValue={endHour}
                    onChangeValue={onChangeEndHour}
                  />
                </div>
                :
                <div className="dateSelect">
                  <DropdownSelect
                    options={minuteList}
                    defaultValue={endMin}
                    onChangeValue={onChangeEndMin}
                  />
                </div>
              </div>
            </div>
            <div className="content">
              <div className="title">
                <h3>전화번호</h3>
                <span>(필수)</span>
              </div>
              <input
                value={phone}
                onChange={onChangePhone}
                type="number"
                placeholder="-없이 숫자만 입력해주세요"
              />
            </div>
            <div className="content">
              <label>
                카카오톡 알림을 받아보시겠어요?
                <input
                  type="checkbox"
                  id={`isAlways`}
                  autoFocus={false}
                  checked={isPush === 1}
                  onChange={() => setIsPush(isPush === 0 ? 1 : 0)}
                />
                <div className={`checkbox ${isPush && 'active'}`}>
                  <img src={`${process.env.PUBLIC_URL}/svg/ic_check_white.svg`} alt="체크박스" />
                </div>
              </label>
              <div className="warningSign">
                <img src={`${process.env.PUBLIC_URL}/svg/ic_warning.svg`} alt="ic" />
                <p>
                  동일한 시간에 여러 직원이 있을 경우, 가장 최근에 등록된 세 명의 직원에게만
                  알림톡이 전송됩니다.
                </p>
              </div>
            </div>
          </div>
          <div className="modalFooter">
            <button className="confirmButton" onClick={setConciergeList}>
              <h3>{employeeId !== null ? '수정하기' : '추가하기'}</h3>
            </button>
          </div>
        </div>
      </Style>
    </Modal>
  );
};

export default AddStaffModal;

const Style = styled.div`
  h3 {
    font-size: 18px;
    font-weight: 500;
    color: #555;
  }
  span {
    font-size: 14px;
    font-weight: 500;
    color: #40977f;
  }
  li::marker {
    color: #4dd2ae;
  }

  .modalTitle {
    .headerBar {
      width: 44px;
      height: 5px;
      margin: 0 auto;
      border-radius: 10px;
      background: #4dd2ae;
    }
    h2 {
      margin-top: 22px;
      font-size: 24px;
      font-weight: 500;
      color: #555;
      text-align: center;
    }
  }

  /* modalContent */
  .modalContent {
    padding: 8% 10%;
  }
  .content {
    width: 100%;
    margin-bottom: 30px;

    input {
      width: 100%;
      padding: 11px 22px;
      border: 1px solid #cecece;
      border-radius: 5px;
    }
  }

  .title {
    display: flex;
    align-items: center;
    gap: 4px;
    margin-bottom: 6px;

    .allSelectButton {
      margin-left: 8px;
      border: 1px solid #4dd2ae;
      font-size: 14px;
      line-height: 20px;
      border-radius: 4px;
      color: #4dd2ae;
    }
    .allSelectButton.active {
      background: #4dd2ae;
      color: #fff;
      font-weight: 700;
    }
  }
  .dayButtonWrap {
    display: flex;
    gap: 10px;
    flex-wrap: wrap;
  }
  .dayButton {
    width: 82px;
    max-width: 82px;
    padding: 10px;
    border-radius: 4px;
    border: 1px solid #cecece;
  }
  .dayButton.active {
    background: #4dd2ae;
    border-color: #4dd2ae;
    color: #fff;
  }
  .selectDateWrap {
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 10px;
  }
  .dateSelect {
    flex: 1;
  }

  .modalFooter {
    padding: 4% 10% 0 10%;
  }
  .confirmButton {
    margin: 0;
    width: 100%;
    padding: 12px 0;
    background: #4dd2ae;
    border: none;
    h3 {
      font-weight: 700;
      color: #fff;
    }
  }

  input[type='checkbox'] {
    display: none;
  }
  label {
    padding: 4px 0;
    width: min-content;
    display: flex;
    align-items: center;
    font-size: 18px;
    line-height: 24px;
    font-weight: 500;
    gap: 8px;
    color: #555555;
    white-space: nowrap;
  }
  .checkbox {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 18px;
    height: 18px;
    border-radius: 3px;
    background: #ffffff;
    border: 1px solid #d2d2d2;
  }
  .checkbox.active {
    background: #4dd2ae;
    border: 1px solid #4dd2ae;
  }

  @media (max-width: 900px) {
    .modalWrapper {
      height: 100vh;
      background: #ffffff;
      padding: 40px 0;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
    }

    .modalTitle {
      .headerBar {
        display: none;
      }
      h2 {
        margin-top: 0;
        font-size: 20px;
      }
    }
    .modalContent {
      padding: 6%;
    }

    .modalFooter {
      padding: 4% 6% 0 6%;
    }
  }
`;
